// extracted by mini-css-extract-plugin
module.exports = {"zone-table":"availabilityZoneTable_zone-table__cnoZG","zone-group":"availabilityZoneTable_zone-group__2elYW","row-type-text":"availabilityZoneTable_row-type-text__3RF5m"};